// extracted by mini-css-extract-plugin
module.exports = {"custom-modal-style":"BillingDialog_custom-modal-style__2hzQi"};